import { Injectable } from '@angular/core';
import {isArray} from 'lodash';
import { UtilHttpStatus, UtilType } from '@formbird/shared';
import { ElasticSearchFilter } from '../../utils/indexeddb/ElasticSearchFilter';
import { ElasticSearchWhereClause } from '../../utils/indexeddb/ElasticSearchWhereClause';
import { IndexedDBConnectorService } from './indexed-dbconnector.service';

const logger = console;

@Injectable({
  providedIn: 'root'
})
export class ElasticIndexedDBService {

  constructor(
    private indexedDBConnectorService: IndexedDBConnectorService
  ) {
  }

  private getDatabase() {
    return this.indexedDBConnectorService.getDatabase();
  }

  private getMinimumShouldMatch(query) {

    if (query && query.bool && query.bool.should) {

      if (query.bool.minimum_should_match !== null &&

        query.bool.minimum_should_match !== undefined) {
        return query.bool.minimum_should_match;

      }

//                TODO reinstate the following as part of Mantis 12596. There are differences between the default
//                minimum_should_match in ElasticSearch 6 and ElasticSearch 2

//                var must = query.bool.must;
//                var filter = query.bool.filter;
//
//                if (!UtilType.hasValue(must) && !UtilType.hasValue(filter)) {
//                 return 1;
//                }
//                if (UtilType.hasValue(filter) && UtilType.hasValue(filter.bool) && UtilType.hasValue(filter.bool.should)) {
//                 return 1;
//                }
//                if (UtilType.hasValue(must) || UtilType.hasValue(filter)) {
//                 return 0;
//                }
    }

    // return 1 until we move to ElasticSearch 6 in Mantis 12596
    return 1;
  }

  // /**
  //  THIS METHOD IS NOT USED ANY WHERE. WILL BE CONVERTED TO ANGULAR LATER.
  //  * add each entry in the ElasticSearch query to a must query that can be passed to the dexie where function as an object
  //  * @param whereClause
  //  * @param mustClause
  //  */
  // addRangeQueryToWhereClause(whereClause, mustClause) {
  //   // whereClause can be an object or an array - an object is only used for running the initial where clause because
  //   // passing an array to dexie requires a compound index on all fields and we can't do that with arrays like appTags that
  //   // are commonly used
  //   if (!isObject(whereClause)) {
  //     logger.error("Please pass the where clause as an object to ElasticSearchWhereClause.addMustQueryToWhereClause");
  //     return;
  //   }
  //
  //   let hasAdded = false;
  //   if (mustClause) {
  //     if (isArray(mustClause)) {
  //       for (let i = 0; i < mustClause.length; i++) {
  //         //match - {key: {query: value}}
  //         //match - {key: value}
  //         if (mustClause[i]['match']) {
  //           angular.forEach(mustClause[i]['match'], function (bean, key) {
  //             var value = bean.query ? bean.query : bean;
  //             addWhereClauseEntry(whereClause, key, value);
  //             hasAdded = true;
  //           });
  //         }
  //         //match_phrase - {key: {query: value}}
  //         //match_phrase - {key: value}
  //         if (mustClause[i]['match_phrase']) {
  //           angular.forEach(mustClause[i]['match_phrase'], function (bean, key) {
  //             var value = bean.query ? bean.query : bean;
  //             addWhereClauseEntry(whereClause, key, value);
  //             hasAdded = true;
  //           });
  //         }
  //         //term - {key: value}
  //         if (mustClause[i]['term']) {
  //           angular.forEach(mustClause[i]['term'], function (bean, key) {
  //             var value = bean;
  //             addWhereClauseEntry(whereClause, key, value);
  //             hasAdded = true;
  //           });
  //         }
  //         //terms - {key: [value1, value2]}
  //         if (mustClause[i]['terms']) {
  //           angular.forEach(mustClause[i]['terms'], function (bean, key) {
  //             var value = bean;
  //             addWhereClauseEntry(whereClause, key, value);
  //             whereClause.push(obj);
  //           });
  //         }
  //       }
  //     } else {
  //       var keys = Object.keys(mustClause);
  //       for (var i = 0; i < keys.length; i++) {
  //         var key = keys[i];
  //
  //         //term - {key: value}
  //         if (key === 'term') {
  //           angular.forEach(mustClause[key], function (bean, key) {
  //             var value = bean;
  //             addWhereClauseEntry(whereClause, key, value);
  //             hasAdded = true;
  //           });
  //         }
  //         //terms - {key: [value1, value2]}
  //         if (key === 'terms') {
  //           angular.forEach(mustClause[key], function (bean, key) {
  //             var value = bean;
  //             addWhereClauseEntry(whereClause, key, value);
  //             hasAdded = true;
  //           });
  //         }
  //         //match - {key: {query: value}}
  //         //match - {key: value}
  //         if (key === 'match') {
  //           angular.forEach(mustClause[key], function (bean, key) {
  //             var value = bean.query ? bean.query : bean;
  //             addWhereClauseEntry(whereClause, key, value);
  //             hasAdded = true;
  //           });
  //         }
  //         //match_phrase - {key: {query: value}}
  //         //match_phrase - {key: value}
  //         if (key === 'match_phrase') {
  //           angular.forEach(mustClause[key], function (bean, key) {
  //             var value = bean.query ? bean.query : bean;
  //             addWhereClauseEntry(whereClause, key, value);
  //             hasAdded = true;
  //           });
  //         }
  //       }
  //     }
  //   }
  //   return hasAdded;
  // };

  private getRangeQueries(filter, ranges) {

    if (!isArray(ranges)) {

      logger.error('Ranges passed to getRangeQueries should be an array');
      return;

    }

    if (filter) {

      if (isArray(filter)) {

        filter.forEach(function (obj) {

          if (obj.range) {

            ranges.push(obj.range);

          }
        });

        return ranges;

      } else {

        ranges.push(filter.range);
      }

      return ranges;
    }

    return null;
  }

  public search(options) {

    const _self = this;

    return new Promise((resolve, reject) => {

        logger.debug('Doing search in ElasticIndexedDBService...');

        if (options.filter) {

          let queryObject;
          if (UtilType.isString(options.filter)) {

            queryObject = options.filter.replace(/'/g, '"');
            queryObject = UtilType.isString(queryObject) ? JSON.parse(queryObject) : queryObject;

          } else {
            queryObject = options.filter;
          }

          logger.info('Elastic IndexedDB Query:');
          logger.info(queryObject);

          if (queryObject
            && queryObject.query
            && queryObject.query.bool) {

            const must = queryObject.query.bool.must;
            const filter = queryObject.query.bool.filter;
            const should = queryObject.query.bool.should;
            const mustNot = queryObject.query.bool.must_not;

            const minimumShouldMatch = _self.getMinimumShouldMatch(queryObject.query);

            const whereClause = {}; // where clause run in the initial query - this can only have one occurrence of any field
            const additionalWhereClauseArray = []; // additional where clauses. If there is more than one occurrence of a
                                                 // field in the query, it will be placed in here to overcome the limitation
                                                 // of having one occurrence of a field in the initial where clause
            ElasticSearchWhereClause.addMustQueryToWhereClause(whereClause, must, additionalWhereClauseArray, false);
            ElasticSearchWhereClause.addMustQueryToWhereClause(whereClause, filter, additionalWhereClauseArray, false);

            const notWhereClauseArray = [];
            ElasticSearchWhereClause.addMustQueryToWhereClause(notWhereClauseArray, mustNot, null, true);

            const shouldClauseDataArray = [];
            const shouldClauseArray = [];
            // don't process the shoulds if minimum should match is 0 because we don't do the score. If minimum should match
            // is 0 then it doesn't cause documents to be excluded - only to increase the score if the document matches the
            // should. If we add the score in future we would need to remove the following if statement
            ElasticSearchWhereClause.addMustQueryToWhereClause(shouldClauseArray, should, null, false);
            shouldClauseDataArray.push({
              shouldClauseArray: shouldClauseArray,
              minimumShouldMatch: minimumShouldMatch
            });

            ElasticSearchWhereClause.addTermsQueryToShouldClauseArray(shouldClauseDataArray, must, 1);
            ElasticSearchWhereClause.addTermsQueryToShouldClauseArray(shouldClauseDataArray, filter, 1);
            ElasticSearchWhereClause.addTermsQueryToShouldClauseArray(shouldClauseDataArray, should, minimumShouldMatch);

            const rangeQueries = [];
            _self.getRangeQueries(queryObject.query.range, rangeQueries);
            _self.getRangeQueries(must, rangeQueries);
            _self.getRangeQueries(filter, rangeQueries);

            const notRangeQueries = [];
            _self.getRangeQueries(mustNot, notRangeQueries);
            logger.info('Must Not Range Clause: ' + JSON.stringify(notRangeQueries));

            logger.info('Where Clause: ' + JSON.stringify(whereClause));
            logger.info('Not Where Clause: ' + JSON.stringify(notWhereClauseArray));
            logger.info('Should Clause Data: ' + JSON.stringify(shouldClauseDataArray));
            logger.info('Additional where clause: ' + JSON.stringify(additionalWhereClauseArray));
            logger.info('Range clause: ' + JSON.stringify(rangeQueries));

            const ors = {
              match: [],
              matchPhrase: [],
              term: [],
              terms: [],
              range: []
            };

            _self.getDatabase().then(
              function success(database) {
                // use a dexie filter to filter out the documents that do not match the not where clause in the query.
                // details of the filters are at http://dexie.org/docs/Collection/Collection.and()
                const dexieFilter = function(filterObject) {
                  // initialise filter result to true - then it will be changed to false if any of the conditions
                  // are not met
                  let result = true;

                  const filterDocument = filterObject;

                  // PROCESS THE ADDITIONAL WHERE CLAUSES

                  for (let k = 0; k < additionalWhereClauseArray.length; k++) {
                    let fieldName = additionalWhereClauseArray[k].key;

                    // if there is a dot in the fieldName - it can be a search for a value within an array or a
                    // search for a plain field value
                    const fieldNameDotPos = fieldName.indexOf('.');

                    let nestedFieldName;

                    if (fieldNameDotPos > 0) {
                      nestedFieldName = fieldName.substring(fieldNameDotPos + 1);
                      fieldName = fieldName.substring(0, fieldNameDotPos);
                    }

                    if (isArray(filterDocument[fieldName])) {
                      let found = false;

                      for (let l = 0; l < filterDocument[fieldName].length; l++) {
                        const comparisonField = fieldNameDotPos > 0 ?
                          filterDocument[fieldName][l][nestedFieldName] :
                          filterDocument[fieldName][l];

                        if (comparisonField === additionalWhereClauseArray[k].value) {
                          found = true;
                          break;
                        }
                      }

                      if (!found) {
                        result = false;
                      }
                    } else {
                      let comparisonValue;

                      if (fieldNameDotPos > 0) {
                        if (filterDocument[fieldName] && filterDocument[fieldName][nestedFieldName]) {
                          comparisonValue = filterDocument[fieldName][nestedFieldName];
                        }
                      } else {
                        comparisonValue = filterDocument[fieldName];
                      }

                      const whereClauseValue = additionalWhereClauseArray[k].value;

                      if (comparisonValue !== whereClauseValue) {
                        result = false;
                        break;
                      }
                    }
                  }

                  if (result) {
                    result = ElasticSearchFilter.filterNotWhere(filterDocument, notWhereClauseArray);
                  }

                  if (result) {
                    for (let idx = 0; idx < shouldClauseDataArray.length; idx++) {
                      const item = shouldClauseDataArray[idx];
                      result = ElasticSearchFilter.filterShould(filterDocument,
                        item.shouldClauseArray,
                        item.minimumShouldMatch);

                      if (!result) {
                        break;
                      }
                    }
                  }

                  if (result) {
                    result = ElasticSearchFilter.filterRange(filterDocument, notRangeQueries, true);
                  }

                  return result;
                };

                let collections;
                if (whereClause && Object.keys(whereClause).length) {
                  collections = database.documents.where(whereClause);
                } else {
                  // in case no where clause, just get all
                  collections = database.documents.toCollection();
                }

                const filterCollection = collections.filter(
                  dexieFilter
                );

                const isCountQuery = options.size === 0;

                // promise that will be returned depending on whether this is a count query or a normal query. A count
                // query is when the size is set to 0 and the count function will be executed instead of the each
                // function
                let eachPromise;

                // write results in the same format as the Elastic search results so the client will be able to process
                // the results as though they are from ElasticSearch
                const esResult = {
                  data: {
                    hits: {
                      total: 0,
                      hits: []
                    }
                  },
                  statusCode: UtilHttpStatus.OK
                };

                if (!isCountQuery) {
                  eachPromise = filterCollection.each(
                    function (document) {
                      if (document) {
                        // add the result to the ElasticSearch results
                        const esSource = {
                          _source: document
                        };

                        esResult.data.hits.hits.push(esSource);
                        esResult.data.hits.total++;
                      } else {
                        logger.warn('ElasticSearch IndexedDB Result returned with no document');
                      }
                    }
                  );
                } else {
                  eachPromise = filterCollection.count(function(count) {
                    esResult.data.hits.total = count;
                  });
                }

                // resolve the promise for the results
                eachPromise.then(function () {
                  resolve(esResult);
                });
              },
              function errorFunc(err) {
                reject(new Error('Could not open indexedDB!'));
              });

          } else {
            const msg = 'Query is empty or searching text on indexedDB is not supported at the moment.';
            reject(new Error(msg));
          }

        }
    });
  }
}
